import { faInfoCircle } from "@fortawesome/pro-light-svg-icons/faInfoCircle";
import { faRotateRight } from "@fortawesome/pro-solid-svg-icons/faRotateRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormatter } from "next-intl";
import { useRouter } from "next/router";
import { toast } from "react-toastify";
import { useTranslations } from "use-intl";
import useConfirmModal from "../../../hooks/useConfirmModal";
import { useAppSelector } from "../../../redux/hooks";
import Button from "../../Button/Button";
import styles from "./CalculatorLeftArea.module.scss";

type CalculatorLeftAreaProps = {
  category: string;
};

function CalculatorLeftArea({ category }: CalculatorLeftAreaProps) {
  const t = useTranslations("Co2CalculatorIndexPage");
  const format = useFormatter();
  const router = useRouter();
  const yearlyCo2e = useAppSelector(
    (state) => state.calculator.session?.yearlyCo2e
  );
  const { openConfirmModal } = useConfirmModal();

  const deleteCalcSession = async () => {
    const p = await openConfirmModal(
      t("confirmRestartSessionTitle"),
      t("confirmRestartSessionDesc"),
      false
    );
    if (!p) return;
    const resp = await fetch("/api/co2-calculator/s/storage", {
      method: "DELETE",
    });
    if (!resp.ok) {
      toast.error(t("errorDeletingSession"));
    }
    router.reload();
  };

  return (
    <>
      <div className={styles.cat}>{category}</div>
      <div className={styles.sum}>
        <div className={styles.h}>{t("calculateYourFootprint")}</div>
        <div className={styles.yearlyCo2e}>
          <span className={styles.co2e}>
            {format.number((yearlyCo2e ?? 0) / 1000, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
          </span>
          <div className={styles.s}>
            {t("tonnesCo2e")}

            <div className={styles.hint}>
              <FontAwesomeIcon icon={faInfoCircle} />
              <div className={styles.hintContent}>{t("co2eExplanation")}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.restart}>
        <Button
          onClick={deleteCalcSession}
          color="green"
          className={styles.restartBt}
        >
          <FontAwesomeIcon icon={faRotateRight} />
          {t("startNewCalculationAction")}
        </Button>
      </div>
    </>
  );
}

export default CalculatorLeftArea;
